<template>
  <div>
    <div class="side-frame-success" style="display: inline-block;">
      <span style="font-size: 14px; color: #606266">
        {{ text }}
      </span>
    </div>
    <div v-if="!disabled" style="display: inline-block;">
      <el-divider direction="vertical"></el-divider>
      <b-button
        v-if="showAdd"
        class="ml-2"
        size="sm"
        variant="outline-success"
        @click="$emit('openEditDialog', { type: 'add' })"
        ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
      </b-button>
      <b-button
        v-if="showDel"
        class="ml-2"
        size="sm"
        variant="outline-danger"
        @click="$emit('del')"
        ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: { type: String, default: '' },
    showAdd: { type: Boolean, default: true },
    showDel: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
}
</script>
